'use strict';
const angular = require('angular');

export class bulletinsWidgetComponent {

  constructor(BulletinService) {
    'ngInject';

    this.BulletinService = BulletinService;
  }

  getPreviewText(text) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ').substr(0, 150) + '...' : '';
  }

  $onInit() {
    this.BulletinService.getNewest({count: this.count || 3}, data => {
      this.data = data;
    }, err => {
      console.log('could not retrieve newest bulletin board posts');
    });
  }
}

export default angular.module('conduuApp.bulletinsWidget', [])
  .component('bulletinsWidget', {
    template: require('./bulletins-widget.component.html'),
    bindings: {
      count: '@'
    },
    controller: bulletinsWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/bulletins-widget/bulletins-widget.component.js